import { Component, OnInit, Renderer2, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { LanguageServiceService } from './services/language-service.service';
import { DeviceDetectorService } from './services/device-detector.service';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})

export class AppComponent implements OnInit {
  title = 'bluebox';
  isMobile: boolean = false;
  isAr: boolean = false;
   deferredPrompt: any;
  showInstallButton = false;
  private arabicStyleId = 'arabic-style';
  constructor(private _languageService: LanguageServiceService,
    private deviceService: DeviceDetectorService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) { }

  ngOnInit(): void {
    localStorage.setItem('language','ar')
    this.isMobile = this.deviceService.isMobileDevice();
    this.isAr = localStorage.getItem('language') == 'ar';
    this._languageService.currentDirection$.subscribe((direction) => {
      document.documentElement.dir = direction;
    if (direction === 'rtl') {
        this.addArabicStylesheet();
      } else {
        this.removeArabicStylesheet();
      }
    });
    this.checkSession();
        window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault(); // Prevent the browser prompt
      this.deferredPrompt = event;
      this.showInstallButton = true;
    });
  }
    installPWA(): void {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted the A2HS prompt');
        } else {
          console.log('User dismissed the A2HS prompt');
        }
        this.deferredPrompt = null;
        this.showInstallButton = false;
      });
    }
  }
  private addArabicStylesheet(): void {
    if (!this.document.getElementById(this.arabicStyleId)) {
      const linkEl = this.renderer.createElement('link');
      linkEl.id = this.arabicStyleId;
      linkEl.rel = 'stylesheet';
      linkEl.href = '/assets/styles-ar.css'; // ✅ COMPILED CSS only
      this.renderer.appendChild(this.document.head, linkEl);
    }
  }

  private removeArabicStylesheet(): void {
    const existingLink = this.document.getElementById(this.arabicStyleId);
    if (existingLink) {
      this.renderer.removeChild(this.document.head, existingLink);
    }
  }
  changeLanguage(language: string) {
    this._languageService.changeLanguage(language);
  }

  showPopup: boolean = false;

  openPopup() {
    this.showPopup = true;
  }

  closePopup() {
    this.showPopup = false;
  }

  setCookie(c_name: any, value: any, exdays: any) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + exdays);
    var c_value = escape(value) + ((exdays == null) ? "" : "; expires=" + exdate.toUTCString());
    document.cookie = c_name + "=" + c_value;
  }

  getCookie(c_name: any) {
    var c_value = document.cookie;
    var c_start = c_value.indexOf(" " + c_name + "=");
    if (c_start == -1) { c_start = c_value.indexOf(c_name + "="); } if (c_start == -1) { c_value = ''; }
    else {
      c_start = c_value.indexOf("=", c_start) + 1;
      var c_end = c_value.indexOf(";", c_start);
      if (c_end == -1) { c_end = c_value.length; }
      c_value = unescape(c_value.substring(c_start, c_end));
    }
    return c_value;
  }



  checkSession() {
    var c = this.getCookie("visited");
    if (c != "yes")
      this.showPopup = true;

    this.setCookie("visited", "yes", null);
  }


}
